import * as yup from "yup";

export const ClientExpenseSchema = yup.object().shape({
  projectSelection: yup.string().required("Required"),
  siteSelection: yup.string(),
  vendor: yup.string().required("Required"),
  expenseDate: yup.date().required("Required"),
  expenseType: yup.string().required("Required"),
  expenseFor:  yup.string().required("Required"),
  uploadBill: yup
    .mixed()
    .test("is-valid-size", "Max allowed size is 10MB", (value) => {
      if (value && value.size) {
        return value.size <= 10 * 1024 * 1024;
      } else {
        return true;
      }
    }),
  expenseAmount: yup.number().required("Required"),
  gstAmount: yup.number().required("Required"),
  paidBy: yup.string().required("Required"),
  paymentMode: yup.string().required("Required"),
  notes: yup.string().required("Required"),
});
